import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { logout } from '../utils/auth';

export interface TrainingItemAPI {
  id: number; // userTrainingId
  createdAt: string;
  finishedAt: string | null;
  training: {
    id: number;
    title: string;
    subtitle?: string;
    description?: string;
    totalSections: number;
    finishedSections: number;
  };
}

export interface TrainingsResponseAPI {
  trainings: TrainingItemAPI[];
  activeTrainingId: number | null;
}

export interface TrainingSummary {
  id: number; // userTrainingId
  createdAt: string;
  title: string;
  subtitle?: string;
  description?: string;
  totalSections: number;
  finishedSections: number;
  finishedAt: string | null;
}

const queryOptions = {
  queryKey: ['trainings'],
  queryFn: async () => {
    const apiKey = localStorage.getItem('apiKey');
    try {
      const { data } = await axios.get<TrainingsResponseAPI>(
        `${process.env.REACT_APP_STUDIO_API_URL}/pwa/user-training`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${apiKey}`,
          },
        }
      );
      //console.log('[useTrainings] raw trainings', data);
      const mapped = data.trainings.map((t) => ({
        id: t.id,
        createdAt: t.createdAt,
        title: t.training.title,
        subtitle: t.training.subtitle,
        description: t.training.description,
        totalSections: t.training.totalSections,
        finishedSections: t.training.finishedSections,
        finishedAt: t.finishedAt,
      }));
      const result = { list: mapped, activeTrainingId: data.activeTrainingId } as { list: TrainingSummary[]; activeTrainingId: number | null };
      //console.log('[useTrainings] mapped', result);
      return result;
    } catch (error: any) {
      if (error.response && error.response.status === 401 && error.response.data.error === 'Invalid or missing API key') {
        logout();
      }
      throw error;
    }
  },
} as any;

export const useTrainings = () => {
  return useQuery<{ list: TrainingSummary[]; activeTrainingId: number | null }, Error>(queryOptions);
};


